import React from 'react';
import styles from './CustomNoData.module.css';
import {ReactComponent as NoDataIcon} from '../../assets/icons/icon_no_data.svg';
import CustomText from '../customText/CustomText';
import { CustomTextMarkdown } from '..';
import { useTranslation } from 'react-i18next';

type CustomNoDataProps = {
    message: string;
}

const CustomNoData = (props: CustomNoDataProps) => {
    const {t} = useTranslation();

    return (
        <div className={styles.containerNoData}>
            <NoDataIcon />
            <CustomText bold className={styles.title}>{t('custom_no_data.title')}</CustomText>
            <CustomTextMarkdown>{props.message}</CustomTextMarkdown>
        </div>
    );
}

export default CustomNoData;